import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-black w-full flex flex-col items-center gap-[64px] px-6 md:px-[72px] py-[64px]">
      {/* Navigation Links */}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-center max-w-[1296px] w-full text-center">
        <Link className="flex-1 text-white font-bold text-base leading-6 hover:underline" to="/shipping-policy">Shopping policy</Link>
        <Link className="flex-1 text-white font-bold text-base leading-6 hover:underline" to="/users-terms-conditions">Users terms and conditions</Link>
        <Link className="flex-1 text-white font-bold text-base leading-6 hover:underline" to="/acceptable-use-policy">Acceptable use policy</Link>
        <Link className="flex-1 text-white font-bold text-base leading-6 hover:underline" to="/privacy-policy">Privacy policy</Link>
      </div>

      {/* Logo */}
      <img
        alt="WearTwice Logo"
        loading="lazy"
        width="300"
        height="121"
        className="mx-auto"
        src="/images/logo_full.svg"
      />

      {/* Copyright */}
      <p className="text-white font-bold text-base leading-6 text-center">
        ©2025 WearTwice. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
